import * as types from '../constants/ActionTypes';
import * as collections from '../constants/shopCollections';

const initialState = {
  data: collections.collections,
  gender: 'men',
  collection: 1
}

const shop = (state = initialState, action) => {
  switch (action.type) {

    case types.SET_SHOP_LOADING:
      return {
        ...state,
       isLoaded: false
      }

    case types.SET_SHOP_LOADED:
      return {
        ...state,
       isLoaded: true
      }

    case types.CHANGE_SHOP_COLLECTION:
      return {
        ...state,
        collection: action.payload
      }

    case types.CHANGE_SHOP_GENDER:
      return {
        ...state,
       gender: action.payload
      }

    default:
      return state;
  }
}

export default shop;


// WEBPACK FOOTER //
// ./src/store/reducers/Shop.js